module.exports = __webpack_public_path__ + "static/media/emaillogo.7111a953.png";